<script>
import { generateMapChart } from "@/shared/charts/map/map-chart";
import * as d3 from "d3-new";
import {debounce} from "lodash";

export default {
  name: "MapChart",
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    color: {
      type: Array,
      required: true,
    },
    valuesToShow: {
      type: Array,
      required: true,
    },
    config: {
      type: Object,
      required: true,
    },
    parentHeight: {
      type: Boolean,
      required: true,
    },
    pointSize: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    chartData: function () {

      this.drawChart();
    },
  },
  async mounted() {
    this.map = await d3.json(
      "/static/map/world.geojson"
    );
    await this.drawChart();
  },
  methods: {
    drawChart: debounce(async function () {
      if(!this.map?.features || !this.$refs.container) {return}
      this.$refs.container.firstChild?.remove();
      var width = this.$refs.container.getBoundingClientRect().width ?? 0;
      var height = this.parentHeight
        ? this.$refs.container?.parentElement?.getBoundingClientRect().height ??
          0
        : this.config.height;
      var zoom = this.parentHeight ? height / 10 : 5;
      var pointSize = this.pointSize || (this.parentHeight ? height / 40 : 5);
      // Append the SVG element.
      var node = await generateMapChart(
        [...this.chartData],
        this.map.features,
        this.valuesToShow,
        this.color,
        { ...this.config, width, height },
        zoom,
        pointSize
      );
      if (node !== null) {
        this.$refs.container.append(node);
      }
    }, 100)
  },
};
</script>

<template>
  <div ref="container" class="map-chart-svg"></div>
</template>

<style>
.map-chart-svg {
  flex-grow: 1;
  svg {
    width: 100%;
  }
}
</style>
